/* unspun: "Check a country" search + filters for the CBD legality article (added 2026-10-02).
   Loaded only on article cbd-oil-legality-by-country (sections/main-article.liquid). Reads the table already in the page. */
(function () {
  function init() {
    var tool = document.querySelector('.leg-tool');
    var table = document.querySelector('.leg-table');
    if (!tool || !table) return;
    var input = document.getElementById('leg-q');
    var card = document.getElementById('leg-card');
    var list = document.getElementById('leg-list');
    var all = document.getElementById('leg-all');
    var rows = [].slice.call(table.querySelectorAll('tbody tr[data-name]'));
    var items = rows.map(function (r) {
      var aliases = (r.getAttribute('data-aliases') || '').split('|').filter(Boolean);
      return { row: r, name: r.getAttribute('data-name'), key: r.getAttribute('data-name').toLowerCase(), aliases: aliases };
    });
    function title(s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

    // Our own suggestion list (the browser's built-in <datalist> is unreliable, e.g. in Safari)
    input.removeAttribute('list');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'leg-sugg');
    var sugg = document.createElement('ul');
    sugg.id = 'leg-sugg';
    sugg.className = 'leg-sugg';
    sugg.setAttribute('role', 'listbox');
    sugg.hidden = true;
    input.parentNode.insertBefore(sugg, card);
    var entries = [];
    items.forEach(function (it) {
      entries.push({ label: it.name, key: it.key, it: it });
      it.aliases.forEach(function (a) { entries.push({ label: title(a) + ' (' + it.name + ')', key: a, it: it, via: a }); });
    });
    var active = -1, current = [];
    function closeSugg() { sugg.hidden = true; sugg.innerHTML = ''; active = -1; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    function matches(q) {
      q = q.trim().toLowerCase();
      if (!q) return [];
      var starts = [], contains = [];
      entries.forEach(function (en) {
        var i = en.key.indexOf(q);
        if (i === 0) starts.push(en); else if (i > 0) contains.push(en);
      });
      return starts.concat(contains).slice(0, 7);
    }
    function renderSugg() {
      current = matches(input.value);
      sugg.innerHTML = '';
      active = -1;
      if (!current.length || (current.length === 1 && current[0].key === input.value.trim().toLowerCase())) { closeSugg(); return; }
      current.forEach(function (en, n) {
        var li = document.createElement('li');
        li.id = 'leg-sugg-' + n;
        li.setAttribute('role', 'option');
        li.textContent = en.label;
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); pick(en); });
        sugg.appendChild(li);
      });
      sugg.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function highlight(n) {
      var lis = sugg.querySelectorAll('li');
      if (!lis.length) return;
      active = (n + lis.length) % lis.length;
      [].forEach.call(lis, function (li, k) { li.classList.toggle('leg-on', k === active); li.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', lis[active].id);
    }
    function pick(en) {
      input.value = en.via ? title(en.via) : en.it.name;
      closeSugg();
      show({ it: en.it, via: en.via }, input.value);
    }

    function find(q) {
      q = q.trim().toLowerCase();
      if (q.length < 2) return null;
      var i, j;
      for (i = 0; i < items.length; i++) if (items[i].key === q) return { it: items[i] };
      for (i = 0; i < items.length; i++) for (j = 0; j < items[i].aliases.length; j++) if (items[i].aliases[j] === q) return { it: items[i], via: q };
      for (i = 0; i < items.length; i++) if (items[i].key.indexOf(q) === 0) return { it: items[i] };
      return null;
    }

    function el(tag, cls, text) {
      var x = document.createElement(tag);
      if (cls) x.className = cls;
      if (text) x.textContent = text;
      return x;
    }
    function txt(node) { return node ? node.textContent.trim() : ''; }

    var shown = null;
    function show(res, q) {
      var sig = res ? res.it.name + '|' + (res.via || '') : 'none|' + q.trim();
      if (sig === shown) return; // don't rebuild the card on blur, or a tap on its link is lost
      shown = sig;
      card.innerHTML = '';
      if (!res) {
        if (q.trim().length >= 2) {
          card.textContent = 'We don’t have an entry for “' + q.trim() + '”. Check the spelling or try the country name.';
          card.className = 'leg-card leg-card-on';
        } else card.className = 'leg-card';
        return;
      }
      var r = res.it.row;
      card.appendChild(el('p', 'leg-card-name', res.it.name + (res.via ? ' (' + title(res.via) + ')' : '')));

      // CBD
      var cbd = el('div', 'leg-card-part');
      var h = el('p', 'leg-card-h', 'CBD ');
      h.appendChild(r.cells[1].querySelector('.leg-chip').cloneNode(true));
      cbd.appendChild(h);
      var note = txt(r.cells[0].querySelector('.leg-note'));
      if (note) cbd.appendChild(el('p', '', note));
      var meta = [];
      if (txt(r.cells[3]) && txt(r.cells[3]) !== '-') meta.push('THC limit for CBD products: ' + txt(r.cells[3]));
      if (txt(r.cells[4]) && txt(r.cells[4]) !== '-') meta.push('Daily CBD limit without prescription: ' + txt(r.cells[4]));
      if (meta.length) cbd.appendChild(el('p', 'leg-card-meta', meta.join(' \u00b7 ')));
      card.appendChild(cbd);

      // Cannabis
      var canPart = el('div', 'leg-card-part');
      canPart.appendChild(el('p', 'leg-card-h', 'Cannabis: ' + txt(r.cells[2])));
      var cn = r.getAttribute('data-cannabis-note');
      if (cn) canPart.appendChild(el('p', '', cn));
      card.appendChild(canPart);

      // Sources and table link
      var src = r.cells[0].querySelector('.leg-src');
      if (src) { var s = src.cloneNode(true); s.className = 'leg-card-meta leg-card-src'; card.appendChild(s); }
      var a = el('a', '', 'See it in the full table');
      a.href = '#' + r.id;
      a.addEventListener('click', function (ev) { ev.preventDefault(); reveal(r); });
      card.appendChild(a);
      card.className = 'leg-card leg-card-on';
    }

    function reveal(r) {
      all.open = true;
      setFilter('all');
      rows.forEach(function (x) { x.classList.remove('leg-hit'); });
      r.classList.add('leg-hit');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    function run() { closeSugg(); show(find(input.value), input.value); }
    input.addEventListener('input', function () {
      renderSugg();
      var res = find(input.value);
      if (res && (res.it.key === input.value.trim().toLowerCase() || res.via)) show(res, input.value);
      else if (!input.value.trim()) show(null, '');
    });
    input.addEventListener('focus', function () { if (input.value.trim()) renderSugg(); });
    input.addEventListener('blur', function () { setTimeout(closeSugg, 150); });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown') { ev.preventDefault(); if (sugg.hidden) renderSugg(); highlight(active + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); highlight(active - 1); }
      else if (ev.key === 'Escape') { closeSugg(); }
      else if (ev.key === 'Enter') { ev.preventDefault(); if (!sugg.hidden && active >= 0) pick(current[active]); else if (!sugg.hidden && current.length) pick(current[0]); else run(); }
    });

    // Filters
    var radios = [].slice.call(document.querySelectorAll('.leg-filters input[name="leg-f"]'));
    function setFilter(v) {
      radios.forEach(function (x) { x.checked = x.value === v; });
      rows.forEach(function (r) { r.hidden = !(v === 'all' || r.getAttribute('data-status') === v); });
    }
    radios.forEach(function (x) { x.addEventListener('change', function () { setFilter(x.value); }); });

    // Deep link: #c-spain opens the table at that row
    if (location.hash.indexOf('#c-') === 0) {
      var t = document.getElementById(location.hash.slice(1));
      if (t) reveal(t);
    }
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  } catch (err) { /* page still works as plain HTML */ }
})();
